<template>
  <div class="personalCenter">
    <div class="inner">
      <div class="typeContent">
        <p class="title">
          修改手机号
        </p>
        <div class="innerContent changePhone">
          <div class="item">
            <p class="leftName" style="vertical-align: middle">账号：</p>
            <p class="rightT" style="margin-right: 34px;vertical-align: middle">{{userPhone}}</p>
            <getCode :phoneNumber="userPhone" :type="4" class="t7" style="margin-left: 15px;cursor: pointer;vertical-align: middle!important;">获取验证码
            </getCode>
          </div>
          <div class="item"><p class="leftName">验证码：
            <p class="rightT"><input v-model="code" type="text" placeholder="请输入"></p></div>
          <div class="item"><p class="leftName">新手机号：</p>
            <p class="rightT"><input v-model="newPhone" type="text" placeholder="请输入"
                                     style="display: inline-block;width: 124px;vertical-align: middle!important;">
              <getCode class="t7" :phoneNumber="newPhone" :type="3"
                       style="display: inline-block;margin-left: 15px;cursor: pointer;vertical-align: middle!important;">获取验证码
              </getCode>
            </p>
          </div>
          <div class="item"><p class="leftName">新验证码：</p>
            <p class="rightT"><input v-model="newCode" type="text" placeholder="请输入"></p></div>
        </div>
        <div style="height: 100px;background: #ffffff;padding-top: 30px">
          <div class="saveBtn" @click="save">保存</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapActions, mapGetters} from 'vuex'
  import getCode from '../modules/phoneCode.vue'

  export default {
    data() {
      return {
        userPhone: '',
        newPhone: '',
        code: '',
        newCode: ''
      }
    },
    methods: {
      getData() {
        let _this = this;
//        let userData =  JSON.parse(JSON.stringify(_this.gUserInfo))
        console.log('dqdqwd' + _this.gUserInfo)
        _this.ajpost('/api/user/findUserInfo', {}, function (data) {
          if (data.code != 0) {
            _this.$message({
              message: data.msg,
              type: 'warning'
            });
          } else {
            _this.userName = data.data.userName;
            _this.email = data.data.email;
            _this.companyName = data.data.companyName;
            _this.userPhone = data.data.userPhone;
            _this.imageUrl = data.data.userPhoto;
          }
        })
      },
      save() {
        let _this = this;
        if (_this.pasAgain != _this.newpas) {
          _this.$message({
            message: "重复密码不正确",
            type: 'warning'
          });
          return;
        }
        _this.ajpost('/api/user/updateUserPhone', {
          "newCode": _this.newCode,
          "newPhone": _this.newPhone,
          "oldCode": _this.code,
          "oldPhote": _this.userPhone
        }, function (data) {
          if (data.code != 0) {
            _this.$message({
              message: data.msg,
              type: 'warning'
            });
          } else {
            _this.$message({
              message: '您的手机号修改成功',
              type: 'success'
            });
            _this.$router.push('/personal')
          }
        }, function (err) {
          console.log(err)
        })
      }
    },
    created() {
      this.getData()
    },
    components: {
      getCode
    }
  }
</script>
<style scoped="scoped">
  @import "../../assets/less/userRz.css";
  @import "../../assets/less/personal.css";

  .t7 {
    border: none !important;
    width: auto !important;
    height: inherit !important;
    vertical-align: text-bottom !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/userCenter/changePhone.vue